import NumberedItems from "./NumberedItems";

const NumberedItemsWithProps = ({ blok }: { blok: any }) => {
  return <NumberedItems title={blok.title} items={blok.items} />;
};

export default NumberedItemsWithProps;
